module.exports = __webpack_public_path__ + "static/img/interview-2-1.386bd1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/interview-2-1.png
// module id = nk+T
// module chunks = 1